import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import StudentBanner from '../../assets/perfect-for-student-banner.jpg';
import { getDeviceType } from '../../utils/common';
import { pageAction } from '../../redux_files/actions/page_actions';

const HomeCookedFoodForStudent = () => {
	const dispatch = useDispatch();
	const [deviceType, setDeviceType] = useState(getDeviceType());
	useEffect(() => {
		window.addEventListener('resize', setDeviceType(getDeviceType()));
		return () => window.removeEventListener('resize', setDeviceType(getDeviceType()));
	}, []);

	useEffect(() => {
		document.title = 'Blogs | Home Cooked Food Perfect for Students';
		dispatch(pageAction('Perfect for Students'));
	});
	return (
		<>
			<img src={StudentBanner} alt='Banner' width='100%' height={deviceType !== "mobile" ? "480" : "200"} />
			<div className='container'>
				<article>
					{deviceType === "mobile" ? <h3>🎓 Why Shivay Durga Foods is Perfect for Students</h3> : <h2>🎓 Why Shivay Durga Foods is Perfect for Students</h2>}

					<p>College life is exciting—but also stressful. Students juggle classes, assignments, deadlines, and tight budgets. That’s why Shivay Durga Foods is built to serve students with what they need most: <strong>affordable, tasty, hygienic, and quick meals</strong>.</p>

					<b>🍛 1. Affordable, Budget-Friendly Meals</b>
					<p>
						• Combo meals under ₹100<br />
						• No extra GST or hidden charges<br />
						• Regular meal plans for monthly subscribers
					</p>

					<b>🧠 2. Nutritious and Home-Like</b>
					<p>We focus on wholesome, home-style food that gives energy and comfort.</p>
					<p>
						• Balanced thalis with dal, rice, roti, sabzi<br />
						• Fresh vegetables and clean cooking oil<br />
						• Low-spice, stomach-friendly options available
					</p>

					<b>🧼 3. Clean, Hygienic & Safe</b>
					<p>
						• Daily kitchen sanitation<br />
						• RO-filtered water and clean oil<br />
						• Gloves and head caps for all kitchen staff
					</p>

					<b>🌯 4. Grab-and-Go Options</b>
					<p>
						• Rolls, sandwiches, parathas<br />
						• Ready in minutes—perfect for class breaks
					</p>

					<b>🧾 5. Student Meal Subscriptions</b>
					<p>
						• Weekly/monthly plans for hostelers and PG residents<br />
						• Customizable vegetarian menus<br />
						• Discounts for bulk orders
					</p>

					<b>💬 6. Easy Ordering – Online & Offline</b>
					<p>Students can order via WhatsApp or mobile call—no app needed.</p>

					<b>❤️ 7. Comfort Food That Feels Like Home</b>
					<p>When you’re far from home, a simple dal-chawal or rajma with hot rotis can brighten your day. That’s the kind of <strong>home-style comfort food</strong> we serve.</p>

					<hr />
				</article>
			</div>
		</>
	);
};
export default HomeCookedFoodForStudent;
